var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 14 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23292 7.70804C11.2134 6.48328 11.8114 3.90777 10.5685 1.95557C9.32558 0.00337517 6.71323 -0.586099 4.73279 0.638701C2.75235 1.8635 2.15435 4.43934 3.39724 6.39153C3.73627 6.92384 4.19279 7.37384 4.73279 7.70804C1.90302 8.66591 0.00227204 11.2887 0 14.2379V14.2905C0 14.6454 0.292143 14.9333 0.652159 14.9333H13.3479C13.7079 14.9333 14 14.6454 14 14.2905V14.2379C13.9928 11.2797 12.076 8.65423 9.23292 7.70804ZM6.98286 1.29093C8.60253 1.29093 9.91557 2.58524 9.91557 4.18182C9.91557 5.7784 8.60253 7.07271 6.98286 7.07271C5.36318 7.07271 4.05014 5.7784 4.05014 4.18182V4.17807C4.05242 2.583 5.36471 1.29093 6.98286 1.29093ZM1.31572 13.6477C1.64103 10.5624 4.4418 8.32117 7.57169 8.64181C10.2527 8.91622 12.3716 11.0049 12.65 13.6477H1.31572Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6b209dcb.svg";
export { ForwardRef as ReactComponent };